// extracted by mini-css-extract-plugin
module.exports = {"label_results":"ResultLabel_label_results__p2jZG","opacity_7":"ResultLabel_opacity_7__AyzTO"};